function getMainAxisFromPlacement(placement) {
  return ['top', 'bottom'].indexOf(placement) >= 0 ? 'x' : 'y';
}

export { getMainAxisFromPlacement as default };
//# sourceMappingURL=getMainAxisFromPlacement.js.map
